import { type RefObject, useLayoutEffect, useState } from 'react'

export function useSidePanelContainerFit({
  minMainContentWidth,
  minWidth,
  panelLayoutRef,
}: {
  minMainContentWidth: number
  minWidth: number
  panelLayoutRef: RefObject<HTMLDivElement | null>
}): boolean {
  const [containerFitsSidebar, setContainerFitsSidebar] = useState(true)

  useLayoutEffect(() => {
    const panelLayout = panelLayoutRef.current
    if (!panelLayout) return
    const update = (available: number) => {
      const fits = available >= minWidth + minMainContentWidth
      setContainerFitsSidebar((prev) => (prev === fits ? prev : fits))
    }
    update(panelLayout.getBoundingClientRect().width)
    if (typeof ResizeObserver === 'undefined') return
    const observer = new ResizeObserver((entries) => {
      const entry = entries[0]
      if (entry) update(entry.contentRect.width)
    })
    observer.observe(panelLayout)
    return () => observer.disconnect()
  }, [minMainContentWidth, minWidth, panelLayoutRef])

  return containerFitsSidebar
}
